import { render, staticRenderFns } from "./ext-learning.vue?vue&type=template&id=48d9a87b&scoped=true&"
import script from "./ext-learning.vue?vue&type=script&lang=ts&"
export * from "./ext-learning.vue?vue&type=script&lang=ts&"
import style0 from "./ext-learning.vue?vue&type=style&index=0&id=48d9a87b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d9a87b",
  null
  
)

export default component.exports